export default class InitOnAjax {
	static customInitOnAjaxFunctions = [];

	static defaultInitOnAjax(payload) {
		if (payload.forceRedirect && payload.redirect) {
			window.location.assign(payload.redirect);
		}
	}

	static addInitOnAjaxFunction(callback) {
		this.customInitOnAjaxFunctions.push(callback);
	}
}
